// tslint:disable:completed-docs

import {
    RedplusTariff,
    RedTariff,
    SalesChannel,
    YoungTariff,
} from '@vfde-fe/sails-constants';
import { SET_DEFAULT_STATE } from './constants';
import { ExtractActions } from '@vfde-fe/sails_core';

/**
 * Fire when user enters or leaves hardware flow
 */
const setDefaultState = (
    salesChannel: SalesChannel,
    subscriptionId: RedTariff | YoungTariff | RedplusTariff | null,
    gigakombi: boolean,
    gigakombiToken: string | null,
) => ({
    type: SET_DEFAULT_STATE,
    salesChannel,
    subscriptionId,
    gigakombi,
    gigakombiToken,
});
/**
 * Action Creators Object
 */
export const tariffActionCreators = {
    setDefaultState,
};

/**
 * Action Creators
 */
export type TariffActionCreators = typeof tariffActionCreators;

/**
 * Union Action Type
 */
export type TariffAction = ExtractActions<TariffActionCreators>;
